import { render, staticRenderFns } from "./assetRegist.vue?vue&type=template&id=98820b7c&"
import script from "./assetRegist.vue?vue&type=script&lang=js&"
export * from "./assetRegist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports